import {
  createExternalRouteRef,
  createRouteRef,
} from '@mainstage/core-plugin-api';

export const catalogRootRouteRef = createExternalRouteRef({
  id: 'catalog',
});

export const adminCatalogRouteRef = createExternalRouteRef({
  id: 'admin-catalog',
});

export const templatesRouteRef = createExternalRouteRef({
  id: 'templates',
});

export const rootRouteRef = createRouteRef({
  id: 'wb-catalog-import',
});
